import { AppSettings } from '../../api';
import { AmplifyAppSyncSettings } from './index';

export class AppSettingsMapper {
  public static toAmplifyAppSyncSettings(settings: AppSettings): AmplifyAppSyncSettings {
    return {
      aws_appsync_region: settings.region,
      aws_appsync_graphqlEndpoint: settings.appSyncUrl,
    };
  }
}